module.exports = __webpack_public_path__ + "media/images/expert__ana-maria-markovic-5577184f88cad34031e5ad94892ccceb.jpg";